/**
 * Destino post-firma unificado (OUW-62): form y chat caen en el board.
 * `/status` ya no es el gate — redirige al board conservando la query, así que
 * las dos URLs entran a la misma pantalla.
 * `/application/status` (#479) sigue viva si se abre a mano; ya no es entrada.
 */

export const PORTAL_STATUS_PATH = '/status';
export const PORTAL_BOARD_PATH = '/status/solicitud';

export function portalStatusUrl(quoteId: string): string {
  return `${PORTAL_STATUS_PATH}?quoteID=${encodeURIComponent(quoteId)}`;
}

export function portalBoardUrl(quoteId: string): string {
  return `${PORTAL_BOARD_PATH}?quoteID=${encodeURIComponent(quoteId)}`;
}

/** `/status` y `/status/...`. No matchea `/application/status`. */
export function isOnClientPortalStatus(pathname: string): boolean {
  return pathname === PORTAL_STATUS_PATH || pathname.startsWith(`${PORTAL_STATUS_PATH}/`);
}

export function isOnAnyStatusScreen(pathname: string): boolean {
  return isOnClientPortalStatus(pathname) || pathname.includes('/application/status');
}
